export default __webpack_public_path__ + "static/media/overviewBannerDesktop.70579817.png";